export default __webpack_public_path__ + "static/media/CliniMACS Hematology Flyer.3d49b8cf.pdf";